module.exports = __webpack_public_path__ + "static/img/3.6a7059c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news18/3.png
// module id = skzd
// module chunks = 1